import { Brand, createBranded } from '@deltasierra/type-utilities';

export type UserId = Brand<number, 'UserId'>;
export const UserId = createBranded<UserId>();
